<div class="space-y-6">
  <div class="content">
    <span class="flex flex-row gap-2 items-center font-semibold text-2xl">
      <i class="pi pi-list text-primary text-2xl"></i>
      <span>{{ 'dac.form.resume' | translate }}</span>
    </span>
    <hr />

    <div *ngFor="let doc of documents; let i = index" class="mt-10">
      <div class="flex flex-row items-center justify-between">
        <div class="flex flex-row items-center gap-4">
          <i class="pi pi-file text-primary text-2xl"></i>
          <span class="text-xl font-semibold">{{ doc.name }}</span>
          <!-- <div [ngClass]="['px-2 py-1 frame rounded-full', isCurrentFormValid(i) ? 'bg-primary' : 'bg-red-500 text-white']">
            <span>
              {{ isCurrentFormValid(i) ? ('dac.form.completed' | translate) : ('dac.form.notCompleted' | translate) }}
            </span>
          </div> -->
        </div>
        <!-- <p-button *ngIf="!isCurrentFormValid(i)" type="button" label="{{ 'dac.form.complete' | translate }}" icon="pi pi-pencil"></p-button> -->
      </div>
      <hr class="py-0" />

      <!-- Fields -->
      <div
        class="flex flex-row items-start justify-between gap-10 mt-2"
        *ngFor="let field of doc.dynaFields"
        [ngClass]="{
          'col-span-1': field.type !== DynaFieldType.TABLE,
          'col-span-full': field.type === DynaFieldType.TABLE,
        }">
        <span class="font-bold opacity-70 italic">{{ field.label }}</span>

        <!-- LIST -->
        <span class="font-thin" *ngIf="field.type === DynaFieldType.LIST">
          {{ getListString(field.dynaFieldsId) }}
        </span>

        <!-- TABLE -->
        <div *ngIf="field.type === DynaFieldType.TABLE" class="overflow-x-auto w-1/2 lg:w-full">
          <ng-container *ngIf="getTableData(field.dynaFieldsId) as table">
            <!-- TABLE -->
            <sm-dac-table
              *ngIf="field.type === DynaFieldType.TABLE"
              [rows]="getTableData(field.dynaFieldsId).rows"
              [columns]="getTableKeys(field.dynaFieldsId)"
              [headers]="getTableLabels(field.dynaFieldsId)">
            </sm-dac-table>
          </ng-container>
        </div>

        <!-- DEFAULT -->
        <span class="font-thin" *ngIf="![DynaFieldType.LIST, DynaFieldType.TABLE].includes(field.type)">
          {{ getSingleValue(field) }}
        </span>
      </div>
    </div>
  </div>

  <!-- Confirmation Checkbox -->
  <div [ngClass]="['content p-2', (hasErrorBorder$ | async) ? 'border-red-500 ng-invalid' : '']">
    <div class="flex flex-row items-center gap-2 px-2">
      <sm-form-builder [formObject]="checkboxAtomicForm"></sm-form-builder>
      <label for="agree" [ngClass]="['flex flex-col', (hasErrorBorder$ | async) ? 'text-red-500' : '']">
        <span class="block font-medium">{{ 'common.confirm' | translate }}</span>
        <span class="block text-sm">{{ 'dac.form.iConfirm' | translate }}</span>
      </label>
    </div>
  </div>
</div>
